<template>
    <div>
        <b-form @submit="onSubmit"> 
        <b-row>
            <b-col cols="12" xl="4" class="my-1"> 
              
                    <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                        <font-awesome-icon icon="angle-left" size="2x" />
                    </b-button>
                    <h3 class="text-themecolor my-1"> Trigger {{$route.params.triggerId != 0 ?  "Bewerken" : "Aanmaken"}}</h3>
                
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                
                    <b-form-checkbox switch size="lg">PDF</b-form-checkbox>
                
            <b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7" label="Naam" label-for="input-horizontal">
                <b-form-input id="input-horizontal" v-model="trigger.naam"></b-form-input>
            </b-form-group>
            <b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7" label="Fablet" label-for="input-horizontal">
                <b-form-input id="input-horizontal"  v-model="trigger.keywords"></b-form-input>
            </b-form-group>   
                    <b-form-group label="Factuurmodifers">
                                        <b-form-checkbox id="checkbox-1" name="checkbox-1">
                    Credit
                </b-form-checkbox>
                    </b-form-group>
                
                

                <h2>Kopgegevens</h2>
                <b-form-group label="Factuurnummer" label-for="input-formatter" class="mb-0" >
                    <b-form-input id="factuurnummer" v-model="trigger.factuurnummer" v-on:keyup="getSearchResults(trigger.factuurnummer)"/>
                </b-form-group>
                <b-form-group label="Factuurdatum" label-for="input-formatter" class="mb-0" >
                    <b-form-input id="factuurdatum" v-model="trigger.factuurdatum" v-on:keyup="getSearchResults(trigger.factuurdatum)"/>
                </b-form-group>
                <h2>Bedragen</h2>
                <b-form-group label="Totaalbedrag" label-for="input-formatter" class="mb-0" >
                    <b-form-input id="totaalbedrag" v-model="trigger.totaalbedrag" v-on:keyup="getSearchResults(trigger.totaalbedrag)"/>
                </b-form-group>
            <b-row>
                <b-button size="sm" type="submit"  variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-row>
            </b-col>
            <b-col md="4" class="my-1">            
                    <textarea class="w-100 h-100" v-model="document.filecontent" />          
            </b-col>
            <b-col md="4" class="my-1">            
                    <img src="http://placehold.it/1800x1800" class="img-responsive">              
            </b-col>
        </b-row>
        </b-form>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import Command from './command'

export default {
    name: 'document-trigger',
    data() {
        return {
            command: new Command(),
        }
    },
    computed: {
        ...mapGetters('fmmodule',['document','trigger']),
    },
    methods: {
        ...mapActions('fmmodule',['find','update','executeCommand']),
        goToHome()
        {
            this.$router.push({ name: `documentdetails:index`});      
        },
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'documenten',
                params: vm.command
            };
            vm.update(payload)
                .then(()=> {
                    vm.goTo('index');
                });
        },
        getSearchResults(item)
            {
                var vm = this;
                vm.command.regex = item;
                vm.executeCommand({resource: "documenten/" + vm.command.id +"/regex", params: vm.command})
                     .then(() => {
                         // TODO set DATA TO FIELD
                    }).catch(() => {
                        // TODO Fout
                    });
            }
    },
    created() {
        var vm = this;
        vm.find({
            resource: 'documenten',
            id: this.$route.params.documentId
        });
        vm.find({
            resource: 'triggers',
            id: this.$route.params.triggerId
        });
        vm.command = new Command(vm.document);
    }

}
</script>